export enum InputTypeEnum {
  Text = 'text',
  Password = 'password',
  Number = 'number',
  Decimal = 'decimal',
  TimePicker = 'timePicker',
  Calendar = 'calendar',
  Dropdown = 'dropdown',
  Checkbox = 'checkbox',
  Switch = 'switch',
  Radio = 'radio',
  TextArea = 'textArea',
  Multidropdown = 'multidropdown',
  Phone = 'phone',
  Email = 'email',
  Search = 'search'
}

export type InputTypeEnumValues = `${InputTypeEnum}`;